import { useNavigate } from 'react-router-dom';
import {
  buildNotificationNavigation,
  resolveNotificationRoute,
} from '../utils/notificationRouter';

export function useNotificationRouter() {
  const navigate = useNavigate();

  const handleNotificationNavigation = (notification) => {
    try {
      const { path, state } = buildNotificationNavigation(notification);
      navigate(path, { state });
    } catch (error) {
      console.error('Error routing notification:', error);
      navigate('/dashboard');
    }
  };

  return { handleNotificationNavigation, resolveNotificationRoute };
}
